/** Russian for `uz-b12-platform2.ts`. */
import type { uzB12Platform2 } from "./uz-b12-platform2";

export const ruB12Platform2: Record<keyof typeof uzB12Platform2, string> = {
  "b12plat.egasi": "Владелец:",
  "b12plat.oneTimeLink": "Ссылка для установки пароля одноразовая, передайте её владельцу сами. После этого окна она больше не показывается.",
  "b12plat.kirmagan": "Не входил",
  "b12plat.paketsiz": "Без пакета",
  "b12plat.umumiy-yonalishlar-royxati-har-b": "Общий список направлений: на него опираются поиск и отчёты каждого агентства. Направление нельзя удалить, его можно отключить. Агентство может добавить своё направление, но не может редактировать этот список.",
  "b12plat.har-bir-agentlik-mehmonxona-maso": "Каждое агентство измеряет расстояние от отеля относительно этого списка. Аэропорт нельзя удалить, его можно отключить. При полных координатах считается расстояние по прямой.",
  "b12plat.kapitan-ulay-oladigan-taminotchi": "Поставщики, которых может подключить Kapitan. Список задан в коде, здесь его изменить нельзя. Счета агентств подключаются на экране «Провайдеры».",
  "b12plat.mijozga-yuboriladigan-xabarlarni": "Стандартные тексты сообщений клиенту. Текст в коде, здесь видно, какие переменные требует каждый шаблон.",
  "b12plat.umumiy-mehmonxona-katalogi-mehmo": "Общий каталог отелей. Отели записываются через сопоставление названий провайдеров, вручную не вводятся.",
  "b12plat.parol-saqlangandan-keyin-korsati": "После сохранения пароль не показывается. Счёт будет проверен при следующем поиске.",
  "b12plat.aeroportni-saqlab-bolmadi-iata-k": "Не удалось сохранить аэропорт. Код IATA должен быть из трёх букв и не должен быть в списке.",
  "b12plat.support-agentlik-malumotini-ozga": "Поддержка может менять данные агентства. Каждое действие попадает в журнал.",
  "b12plat.yonalishni-saqlab-bolmadi-nomi-v": "Не удалось сохранить направление. Заполните название и тип.",
  "b12plat.davr-bugundan-boshlanadi-va-pake": "Период начинается сегодня, кредиты пакета выдаются на этот период.",
  "b12plat.barcha-agentliklar-boyicha-yozuv": "Записи по всем агентствам, сначала новые.",
  "b12plat.faqat-korish-har-bir-harakat-jur": "Только просмотр. Каждое действие попадает в журнал.",
  "b12plat.yangi-qiymat-ozgarmasa-bosh-qold": "Новое значение (оставьте пустым, если не меняется)",
  "b12plat.bu-bolimni-faqat-agentlik-egasi": "Этот раздел видит только владелец агентства.",
  "b12plat.sorov-bajarilmadi-qayta-urinib-k": "Запрос не выполнен. Попробуйте ещё раз.",
  "b12plat.faol-yangi-agentliklar-uchun-tan": "Активен (можно выбрать для новых агентств)",
  "b12plat.sabab-majburiy-jurnalga-yoziladi": "Причина (обязательно, попадёт в журнал)",
  "b12plat.filiallar-har-biri-yangi-qatorda": "Филиалы (каждый с новой строки)",
  "b12plat.support-rejimini-boshlab-bolmadi": "Не удалось начать режим поддержки.",
  "b12plat.hali-muvaffaqiyatli-tekshirilmag": "Ещё не проверено успешно",
  "b12plat.holatni-ozgartirib-bolmadi": "Не удалось изменить статус.",
  "b12plat.ozgarishni-saqlab-bolmadi": "Не удалось сохранить изменение.",
  "b12plat.boshqa-nomlari-vergul-bilan": "Другие названия, через запятую",
  "b12plat.qoshimcha-kredit-narxi-uzs": "Цена дополнительного кредита, UZS",
  "b12plat.agentlikni-yaratib-bolmadi": "Не удалось создать агентство.",
  "b12plat.tur-provayderlari-ulanmagan": "Туроператоры не подключены.",
  "b12plat.tolov-boyicha-toxtatilgan": "Остановлено за неуплату",
  "b12plat.xodimlar-soni-0-cheksiz": "Число сотрудников (0 — без ограничения)",
  "b12plat.standart-xabar-shablonlari": "Стандартные шаблоны сообщений",
  "b12plat.tarifni-belgilab-bolmadi": "Не удалось назначить тариф.",
  "b12plat.support-sessiyasi-yopildi": "Сессия поддержки закрыта.",
  "b12plat.support-rejimini-boshlash": "Начать режим поддержки",
  "b12plat.sessiyani-yopib-bolmadi": "Не удалось закрыть сессию.",
  "b12plat.parol-ornatish-havolasi": "Ссылка для установки пароля",
  "b12plat.tarifni-saqlab-bolmadi": "Не удалось сохранить тариф.",
  "b12plat.ozgartirish-ruxsati-bor": "Есть право изменений",
  "b12plat.administrator-toxtatgan": "Остановлено администратором",
  "b12plat.agentlikka-aylantirildi": "Стало агентством",
  "b12plat.qidiruv-elon-qilingan": "Поиск объявлен",
  "b12plat.ai-kreditlari-oyiga": "Кредиты AI (в месяц)",
  "b12plat.integratsiyalar-yoq": "Интеграций нет.",
  "b12plat.yonalish-qoshildi": "Направление добавлено.",
  "b12plat.holat-ozgartirildi": "Статус изменён.",
  "b12plat.holatni-ozgartirish": "Изменить статус",
  "b12plat.ozgartirish-ruxsati": "Право изменений",
  "b12plat.ulanishni-tekshirish": "Проверить подключение",
  "b12plat.umumiy-yonalishlar": "Общие направления",
  "b12plat.mehmonxonalar-yoq": "Отелей нет.",
  "b12plat.agentlik-yaratildi": "Агентство создано.",
  "b12plat.tasdiqlab-bolmadi": "Не удалось подтвердить.",
  "b12plat.aeroport-qoshildi": "Аэропорт добавлен.",
  "b12plat.yonalishlar-yoq": "Направлений нет.",
  "b12plat.provayderlar-yoq": "Провайдеров нет.",
  "b12plat.tarifni-tahrirlash": "Изменить тариф",
  "b12plat.kreditlar-berildi": "Кредиты выданы.",
  "b12plat.sorov-rad-etildi": "Запрос отклонён.",
  "b12plat.rad-etib-bolmadi": "Не удалось отклонить.",
  "b12plat.faol-sessiya-yoq": "Активной сессии нет.",
  "b12plat.kalit-kiritilmagan": "Ключ не введён",
  "b12plat.tarif-belgilandi": "Тариф назначен.",
  "b12plat.tarifni-belgilash": "Назначить тариф",
  "b12plat.kredit-sorovlari": "Запросы кредитов",
  "b12plat.tasdiq-kutilmoqda": "Ждёт подтверждения",
  "b12plat.aeroportlar-yoq": "Аэропортов нет.",
  "b12plat.agentlikka-kirish": "Войти в агентство",
  "b12plat.parolni-yangilash": "Обновить пароль",
  "b12plat.tur-provayderlari": "Туроператоры",
  "b12plat.kirish-rad-etildi": "Вход отклонён",
  "b12plat.javob-tushunarsiz": "Ответ непонятен",
  "b12plat.mahsulot-paket": "Продукт (пакет)",
  "b12plat.faolsizlantirish": "Отключить",
  "b12plat.shablonlar-yoq": "Шаблонов нет.",
  "b12plat.egasining-emaili": "Email владельца",
  "b12plat.sabab-majburiy": "Причина (обязательно)",
  "b12plat.filtrni-tozalash": "Сбросить фильтр",
  "b12plat.parol-yangilandi": "Пароль обновлён",
  "b12plat.parol-rad-etildi": "Пароль отклонён",
  "b12plat.tolov-tizimlari": "Платёжные системы",
  "b12plat.tarif-saqlandi": "Тариф сохранён.",
  "b12plat.oylik-narx-uzs": "Цена в месяц, UZS",
  "b12plat.sorovlar-yoq": "Запросов нет.",
  "b12plat.integratsiyalar": "Интеграции",
  "b12plat.demo-belgilandi": "Демо назначено",
  "b12plat.faollashtirish": "Включить",
  "b12plat.ozgaruvchilar": "Переменные",
  "b12plat.egasining-ismi": "Имя владельца",
  "b12plat.holat-boyicha": "По статусу",
  "b12plat.yozuvlar-yoq": "Записей нет.",
  "b12plat.support-rejimi": "Режим поддержки",
  "b12plat.tekshirilmagan": "Не проверено",
  "b12plat.mamlakat-kodi": "Код страны",
  "b12plat.mehmonxonalar": "Отели",
  "b12plat.audit-jurnali": "Журнал аудита",
  "b12plat.koordinatalar": "Координаты",
  "b12plat.qayta-urinish": "Повторить",
  "b12plat.javob-bermadi": "Не ответил",
  "b12plat.yonalishlar": "Направления",
  "b12plat.nomi-lotin": "Название (латиница)",
  "b12plat.provayderlar": "Провайдеры",
  "b12plat.imkoniyatlar": "Возможности",
  "b12plat.bekor-qilish": "Отмена",
  "b12plat.tasdiqlangan": "Подтверждён",
  "b12plat.faqat-oqish": "Только чтение",
  "b12plat.tizim-holati": "Состояние системы",
  "b12plat.integratsiya": "Интеграция",
  "b12plat.kiritilmagan": "Не введено",
  "b12plat.yangi-holat": "Новый статус",
  "b12plat.yangi-tarif": "Новый тариф",
  "b12plat.rad-etilgan": "Отклонён",
  "b12plat.aeroportlar": "Аэропорты",
  "b12plat.yangi-parol": "Новый пароль",
  "b12plat.boglanildi": "Связались",
  "b12plat.sozlanmagan": "Не настроено",
  "b12plat.shablonlar": "Шаблоны",
  "b12plat.yuborilgan": "Отправлен",
  "b12plat.tasdiqlash": "Подтвердить",
  "b12plat.tahrirlash": "Изменить",
  "b12plat.rad-etildi": "Отклонено",
  "b12plat.ishlayapti": "Работает",
  "b12plat.faol-emas": "Неактивно",
  "b12plat.platforma": "Платформа",
  "b12plat.yonalish": "Направление",
  "b12plat.rad-etish": "Отклонить",
  "b12plat.iata-kodi": "Код IATA",
  "b12plat.provayder": "Провайдер",
  "b12plat.bolimlar": "Разделы",
  "b12plat.mamlakat": "Страна",
  "b12plat.qoshish": "Добавить",
  "b12plat.yaratish": "Создать",
  "b12plat.agentlik": "Агентство",
  "b12plat.boshlash": "Начать",
  "b12plat.saqlandi": "Сохранено",
  "b12plat.tafsilot": "Подробности",
  "b12plat.yopilgan": "Закрыто",
  "b12plat.oldingi": "Назад",
  "b12plat.keyingi": "Далее",
  "b12plat.saqlash": "Сохранить",
  "b12plat.tanlang": "Выберите",
  "b12plat.hammasi": "Все",
  "b12plat.harakat": "Действие",
  "b12plat.kenglik": "Широта",
  "b12plat.uzunlik": "Долгота",
  "b12plat.ulangan": "Подключено",
  "b12plat.shahar": "Город",
  "b12plat.yulduz": "Звёзды",
  "b12plat.yopish": "Закрыть",
  "b12plat.kredit": "Кредиты",
  "b12plat.muddat": "Срок",
  "b12plat.hudud": "Регион",
  "b12plat.holat": "Статус",
  "b12plat.kalit": "Ключ",
  "b12plat.tarif": "Тариф",
  "b12plat.sabab": "Причина",
  "b12plat.login": "Логин",
  "b12plat.yangi": "Новый",
  "b12plat.turi": "Тип",
  "b12plat.nomi": "Название",
  "b12plat.faol": "Активно",
  "b12plat.izoh": "Примечание",
  "b12plat.yoq": "Нет",
  "b12plat.vaqt": "Время",
  "b12plat.amal": "Действие",
  "b12plat.xato": "Ошибка",
  "b12plat.kim": "Кто",
  "b12plat.ha": "Да",
};
